import { Source } from 'app/models/source.enum';
import { PannellumStadiumCamera } from 'app/models/pannellum-stadium-camera';

export class Stadium {
  id: string;
  parentId: string;
  displayName: string;
  createdTime: number;
  source: Source;
  pannellumStadiumCamera: PannellumStadiumCamera[];


  constructor(
    id: string,
    parentId: string,
    displayName: string,
    createdTime: number,
    source: Source,
    pannellumStadiumCamera: PannellumStadiumCamera[]
  ) {
    this.id = id;
    this.parentId = parentId;
    this.displayName = displayName;
    this.createdTime = createdTime;
    this.source = source;
    this.pannellumStadiumCamera = pannellumStadiumCamera;
  }
}
